import ru from './ru';
import en from './en';

const locales = ['ru', 'en'];
const primaryLocale = 'en';
const fallbackLocale = 'ru';

export default {
  ru,
  en,
};

export { locales, primaryLocale, fallbackLocale };
